import * as React from "react";

import { InputDOMProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/base/template/base.tpl.api";

import { ControlContext } from "../modules/processFormEngine/components/contexts";

export function capitalize<T extends string>(value: T): Capitalize<T> {
	return (value.charAt(0).toUpperCase() + value.slice(1)) as Capitalize<T>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-function-type
export function getDecoratorComponentName(Component: React.ComponentType<any>, func: Function): string {
	return [Component.displayName ?? Component.name, "With", capitalize(func.name)].join("");
}

/**
 * This decorator is used to apply the aria-required html attribute to html elements. The attribute can only be applied
 * to components extending {@link InputDOMProps}. The value of the aria-required label will match the isRequired value
 * of the component.
 *
 * @param Component The component to which the aria-required label should be added
 */
export function inputAriaRequiredDecorator<T extends InputDOMProps<HTMLElement>>(Component: React.ComponentType<T>) {
	const displayName = getDecoratorComponentName(Component, inputAriaRequiredDecorator);
	return Object.assign(
		(props: T) => {
			const required = React.useContext(ControlContext)?.isRequired;
			const inputProps = React.useMemo(
				() => ({
					...props.inputProps,
					"aria-required": required
				}),
				[props.inputProps, required]
			);
			return <Component {...props} inputProps={inputProps} />;
		},
		{ displayName: displayName }
	);
}
